// /welcome and /welcome?returnTo=<path> (FR-002, FR-011, FR-013, FR-022). The sanitised returnTo stays
// in the address for sign-in to use; an unsafe value is dropped (data-model §3). After an ended
// session or a refused renewal the user goes straight to Log in, keeping returnTo (002).
import {
  type Href,
  Redirect,
  useLocalSearchParams,
  useRouter,
} from "expo-router";
import { useEffect } from "react";

import { sanitizeReturnTo } from "@/session/access";
import { useSession } from "@/session/hooks";
import { EntryScreen } from "@/shell/EntryScreen";

export default function Welcome() {
  const { returnTo } = useLocalSearchParams<{ returnTo?: string }>();
  const router = useRouter();
  const session = useSession();
  const safe = sanitizeReturnTo(typeof returnTo === "string" ? returnTo : null);
  const unsafe = typeof returnTo === "string" && safe === null;

  useEffect(() => {
    if (unsafe) router.setParams({ returnTo: undefined });
  }, [unsafe, router]);

  if (
    session.status === "signedOut" &&
    (session.reason === "SESSION_ENDED" || session.reason === "NO_ACCESS")
  ) {
    const href = safe
      ? `/login?returnTo=${encodeURIComponent(safe)}`
      : "/login";
    return <Redirect href={href as Href} />;
  }
  return <EntryScreen />;
}
